import i18n, { locale } from "../i18n";
import type { Row, Lookups } from "../config/types";
export const today = () =>
  new Intl.DateTimeFormat("en-CA", { timeZone: "Africa/Tunis" }).format(
    new Date(),
  );
export const localTime = () =>
  new Intl.DateTimeFormat("en-GB", {
    timeZone: "Africa/Tunis",
    hour: "2-digit",
    minute: "2-digit",
  }).format(new Date());
export const formatDate = (value: unknown) =>
  value
    ? new Date(String(value).slice(0, 10) + "T12:00:00").toLocaleDateString(
        locale(),
        { day: "numeric", month: "short", year: "numeric" },
      )
    : "—";
export const initials = (name: string) =>
  name
    .split(" ")
    .map((s) => s[0])
    .slice(0, 2)
    .join("")
    .toUpperCase();
export function display(row: Row, key: string, lookups?: Lookups): string {
  if (key === "departmentIds" || key === "employeeIds") {
    const single = key === "departmentIds" ? "departmentId" : "employeeId";
    const selected = row[key];
    const ids = Array.isArray(selected) && selected.length ? selected : row[single] ? [String(row[single])] : [];
    return ids.length ? ids.map(id => display({ id: row.id, [single]: id }, single, lookups)).join(", ") : i18n.t("Unassigned");
  }
  if (key === "managedDepartmentIds") {
    const ids = row[key];
    return Array.isArray(ids) && ids.length
      ? ids.map(id => {
          const department = lookups?.departments.find(item => item.id === id);
          return String((i18n.resolvedLanguage === "fr" ? department?.nameFr : department?.nameEn || department?.name) || i18n.t("Unavailable department"));
        }).join(", ")
      : i18n.t("No managed departments");
  }
  if (key === "participantIds") {
    const ids = row[key];
    return Array.isArray(ids) && ids.length
      ? ids.map(id => String(lookups?.reservationParticipants?.find(employee => employee.id === id)?.fullName || i18n.t("Unavailable employee"))).join(", ")
      : i18n.t("No participants");
  }
  if (key === "person") return `${row.firstName} ${row.lastName}`;
  if (key === "visitStatus")
    return i18n.t(row.timeOut ? "Checked out" : "On site");
  if (key === "interviewStatus")
    return i18n.t(row.done ? "Completed" : "Scheduled");
  if (key === "employeeId")
    return String(
      lookups?.employees.find((x) => x.id === row[key])?.fullName ||
        i18n.t("Unassigned"),
    );
  if (key === "departmentId")
    return String(
      (() => {
        const department = lookups?.departments.find((x) => x.id === row[key]);
        return i18n.resolvedLanguage === "fr"
          ? department?.nameFr
          : department?.nameEn || department?.name;
      })() ||
        i18n.t("Unassigned"),
    );
  if (key === "roomId")
    return String(
      lookups?.meetingRooms.find((room) => room.id === row[key])?.name ||
        i18n.t("Unassigned"),
    );
  if (key === "floorId")
    return String(
      (() => {
        const floor = lookups?.floors.find((x) => x.id === row[key]);
        return i18n.resolvedLanguage === "fr"
          ? floor?.nameFr
          : floor?.nameEn || floor?.name;
      })() || i18n.t("Unassigned"),
    );
  if (["date", "receivedDate", "deliveredDate", "createdAt"].includes(key))
    return formatDate(row[key]);
  if (["time", "timeIn", "timeOut", "startTime", "endTime"].includes(key))
    return String(row[key] || "—").slice(0, 5);
  if (typeof row[key] === "boolean") return i18n.t(row[key] ? "Yes" : "No");
  if (["status", "role", "type", "reason", "location"].includes(key))
    return i18n.t(String(row[key] || "—"));
  return String(row[key] || "—");
}
